import React from 'react';

const ToolTip = props => {
  const { toolTipText, clsName } = props;

  return (
    <div className={`toolTipWrap ${clsName || ''}`}>
      <div
        className="toolTipTextWrap"
        dangerouslySetInnerHTML={{ __html: toolTipText || '' }}
      />
      <span className="sharpPoint" />
    </div>
  );
};

export default ToolTip;
